export default __webpack_public_path__ + "static/media/bathroom2-afterA.ae3f4beb.jpg";